<template lang="pug">
  #chart
    v-container(fluid)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card.pb-3
            //v-layout.mt-5(row, wrap)
              v-flex.mb-2(xs12)
                Options
            v-layout(row, wrap, d-flex, justify-center)
              v-flex(xs12, md6)
                Bar(:reports="reports")
              v-flex(xs12, md6)
                Treemap(:reports="reports")
            v-layout.px-5.mt-5.mb-4(row, wrap)
              //v-flex.mb-2(xs12)
                p.type Tipo de agresión
              v-flex.legend(xs12, md3, v-for="type in types", v-bind:data="type", v-bind:key="type.title")
                div(v-bind:style="{ backgroundColor: type.color }")
                p.px-2.mb-0 {{type.title}}
</template>

<script>
import Bar from "@/components/Bar.vue";
import Treemap from "@/components/Treemap.vue";
import Options from "@/components/Options.vue";

export default {
  name: "Chart",
  components: {
    Bar,
    Treemap,
    Options
  },
  data() {
    return {
      //reports: this.$store.state.reports,
      stateColors: this.$store.state.stateColors,
      aggressionsTypes: this.$store.state.aggressionsTypes,
      types: []
    };
  },
  computed: {
    reports: function() {
      return this.$store.state.reports;
    }
  },
  watch: {
    reports: function() {
      this.types = this.aggressionsTypes.filter(type => {
        const reports = this.reports.filter(report => {
          return type.title === report.type;
        });
        return reports.length > 0;
      });
      // console.log(this.reports);
    }
  } /*,
  methods: {
    getReports() {
      this.$store.dispatch("getReports");
    }
  },*/,
  mounted() {
    // this.getReports();
    // console.log(this.dataset)
    // console.log(this.labels)
    this.types = this.aggressionsTypes.filter(type => {
      const reports = this.reports.filter(report => {
        return type.title === report.type;
      });
      return reports.length > 0;
    });
  }
};
</script>

<style scoped lang="scss">
#chart {
  .card {
    height: 100vh;
    background-color: #2d2d2d !important;
  }
  .type {
    font-family: "Rajdhani", sans-serif;
    color: white;
    font-size: 15px;
    font-weight: 600;
  }
  .legend {
    display: flex;
    flex-direction: row;
    div {
      height: 15px !important;
      width: 15px !important;
      margin-top: 4px;
    }
    p {
      font-family: "Rajdhani", sans-serif;
      color: white;
      font-size: 15px;
      font-weight: 600;
    }
  }
}
</style>
